import React from 'react';

// components
import Visa from 'dibs-vg/dist/react/payment-visa';
import Discover from 'dibs-vg/dist/react/payment-discover';
import MasterCard from 'dibs-vg/dist/react/payment-mastercard';
import AmericanExpress from 'dibs-vg/dist/react/payment-american-express';
import Paypal from 'dibs-vg/dist/react/payment-paypal';
import WireTransfer from 'dibs-vg/dist/react/payment-wire-transfer';
import Check from 'dibs-vg/dist/react/payment-check';
import Affirm from 'dibs-vg/dist/react/payment-affirm';

// styles
import styles from './PdpSharedPaymentCards.scss';

export const creditCards = (
    <div className={styles.creditCards}>
        <Visa className={styles.card} />
        <Discover className={styles.card} />
        <AmericanExpress className={styles.card} />
        <MasterCard className={styles.card} />
    </div>
);

export const paypal = <Paypal className={styles.card} />;

export const check = <Check className={`${styles.card} ${styles.check}`} />;

export const wireTransfer = <WireTransfer className={`${styles.card} ${styles.wireTransfer}`} />;

export const affirm = <Affirm className={styles.card} />;
